/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Warehouse_DescInputs */

const vi_qr_warehouse_desc = /** @type {(inputs: Qr_Warehouse_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét QR phiếu xuất kho để xác nhận xuất hàng`)
};

/**

* @param {Qr_Warehouse_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_warehouse_desc = /** @type {((inputs?: Qr_Warehouse_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Warehouse_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_warehouse_desc(inputs)
});